<template>
  <div>
    <div id="toolbar" class="editor-toolbar">
      <!--<input  src="/images/icons/image-editor/folder-open-line.svg" type="file" id="uploadImage" accept="image/*" @change="onImageUpload">-->
      <!--<button @click="startCropping">Crop</button>-->
      <button :class="'tt-tool '" title="Crop" @click="startCropping();changeToActive($event)">
        <img style="width:24px;" src="/images/icons/image-editor/crop-line.svg" alt="SVG Image" />
      </button>
      <button :class="'tt-tool '" title="Blur" @click="startBlurring();changeToActive($event)">
        <img style="width:24px;" src="/images/icons/image-editor/drop-line.svg" alt="SVG Image" />
      </button>
      <button :class="'tt-tool '" title="Draw rectangle" @click="startDrawingRect();changeToActive($event)">
        <img style="width:24px;" src="/images/icons/image-editor/rectangle-line.svg" alt="SVG Image" />
      </button>
      <button :class="'tt-tool '" title="Draw arrow" @click="startDrawingArrow();changeToActive($event)">
        <img style="width:24px;" src="/images/icons/image-editor/arrow-right-line.svg" alt="SVG Image" />
      </button>

      <input :class="'tt-tool '" type="color" v-model="fontColor">
      <select @click="removeAcive()" :class="'tt-font '" v-model="fontFace">
        <option value="Arial">Arial</option>
        <option value="Verdana">Verdana</option>
        <option value="Times New Roman">Times New Roman</option>
      </select>
      <input :class="'tt-text '" type="number" v-model="lineWidth" min="1" max="10" style="width: 50px;">
      <button :class="'tt-text '" @click="startAddingText();changeToActive($event)">Add Text</button>
      <button :class="'tt-tool '" title="Undo(CTRL + Z)" @click="undo();removeActive()">
        <img style="width:24px;" src="/images/icons/image-editor/arrow-go-back-line.svg" alt="SVG Image" />
      </button>
      <button :class="'tt-tool '" title="Redo(CTRL + Y)" @click="redo();removeActive()"><img style="width:24px;" src="/images/icons/image-editor/arrow-go-forward-line.svg" alt="SVG Image" /></button>

      <button title="Save(CTRL + S)" :class="'tt-tool '" @click="EmitSave();removeActive()">
        <img style="width:24px;" src="/images/icons/image-editor/save-3-line.svg" alt="SVG Image" />
      </button>
    </div>
    <canvas id="canvas" ref="canvas" @mousedown="onMouseDown" @mousemove="onMouseMove" @mouseup="onMouseUp" @wheel="onWheel"></canvas>
    <input type="text" ref="textInput" v-model="text" placeholder="Enter text" @blur="commitText" @keydown.enter="commitText" style="display: none; position: absolute; border: 1px solid #000; background-color: #fff; z-index: 10;">
  </div>
</template>

<script>
  export default {
    props: {
      base64Image: {
        type: String,
        required: true
      },
      Closing: {
        type: Boolean
      }
    },

    data() {
      return {
        ctx: null,
        image: new Image(),
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0,
        isCropping: false,
        isDrawingRect: false,
        isDrawingArrow: false,
        isAddingText: false,
        isBlurring: false,
        lastSavedStep: 0,
        activeFunction: "",
        drawing: false,
        snapshot: null,
        scale: 1,
        originX: 0,
        originY: 0,
        history: [],
        historyStep: -1,
        fontColor: "#ff1a1a",
        fontFace: "Arial",
        lineWidth: 3,
        text: ""
      };
    },
    watch: {
      watch: {
        Closing(newValue, oldValue) {
          alert("2");
        },
      }
    },
    async mounted() {
      this.mapKeyboardShortcuts()
      this.ctx = this.$refs.canvas.getContext("2d");
      if (this.base64Image.startsWith("data:image")) {
        // Source is already base64
        this.loadImage(this.base64Image);
      } else {
        // Assume source is a URL, convert to base64
        const base64 = await this.convertImageUrlToBase64(this.base64Image);
        this.loadImage(base64);
      }
    },
    methods: {
      mapKeyboardShortcuts() {
        var instance = this;
        document.addEventListener('keydown', function (event) {
          if (event.ctrlKey) {
            switch (event.key) {
              case 's':
                event.preventDefault();
                instance.EmitSave();
                instance.removeActive()
                break;
              case 'y':
                event.preventDefault();
                instance.redo();
                instance.removeActive()
                break;
              case 'z':
                event.preventDefault();
                instance.undo();
                instance.removeActive()
                break;
            }
          }
        });
      },

      loadImage(base64) {

        this.image.src = base64;
        this.image.onload = () => {
          this.$refs.canvas.width = this.image.width;
          this.$refs.canvas.height = this.image.height;
          this.ctx.drawImage(this.image, 0, 0);
          this.saveState();
        };
      },
      async convertImageUrlToBase64(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      },

      saveState() {
        if (this.historyStep < this.history.length - 1) {
          this.history = this.history.slice(0, this.historyStep + 1);
        }
        this.history.push(this.$refs.canvas.toDataURL());
        this.historyStep++;
        var isChanged = this.lastSavedStep != this.historyStep && (this.historyStep > 0 || this.lastSavedStep > 0)
        this.$emit("StateChanged", isChanged);

      },
      restoreState(step) {
        const canvasPic = new Image();
        canvasPic.src = this.history[step];
        canvasPic.onload = () => {
          this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
          this.ctx.drawImage(canvasPic, 0, 0);
        };
      },
      onImageUpload(event) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.loadImage(e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      },
      startCropping() {
        this.isCropping = true;
        this.$refs.canvas.style.cursor = "crosshair";
        this.setActiveFunction("isCropping");
      },
      startDrawingRect() {
        this.isDrawingRect = true;
        this.$refs.canvas.style.cursor = "crosshair";
        this.setActiveFunction("isDrawingRect");
      },
      startDrawingArrow() {
        this.isDrawingArrow = true;
        this.$refs.canvas.style.cursor = "crosshair";
        this.setActiveFunction("isDrawingArrow");
      },
      startBlurring() {
        this.isBlurring = true;
        this.$refs.canvas.style.cursor = "crosshair";
        this.setActiveFunction("isBlurring");
      },
      startAddingText() {
        this.isAddingText = true;
        this.$refs.canvas.style.cursor = "text";
        this.setActiveFunction("isAddingText");
      },
      onMouseDown(e) {
        if (this.isCropping || this.isDrawingRect || this.isDrawingArrow || this.isAddingText || this.isBlurring) {
          this.startX = e.offsetX;
          this.startY = e.offsetY;
          if (this.isDrawingRect || this.isDrawingArrow || this.isCropping || this.isBlurring) {
            this.drawing = true;
            this.snapshot = this.ctx.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
          }
        }
      },
      onMouseMove(e) {
        if (this.drawing) {
          this.ctx.putImageData(this.snapshot, 0, 0);
          this.endX = e.offsetX;
          this.endY = e.offsetY;
          this.ctx.strokeStyle = this.fontColor;
          this.ctx.lineWidth = this.lineWidth;
          if (this.isDrawingRect) {
            this.ctx.strokeRect(this.startX, this.startY, this.endX - this.startX, this.endY - this.startY);
          } else if (this.isDrawingArrow) {
            this.drawArrow(this.ctx, this.startX, this.startY, this.endX, this.endY);
          } else if (this.isCropping || this.isBlurring) {
            this.ctx.setLineDash([5, 5]);
            this.ctx.strokeRect(this.startX, this.startY, this.endX - this.startX, this.endY - this.startY);
            this.ctx.setLineDash([]);
          }
        }
      },
      onMouseUp(e) {
        if (this.isCropping || this.isBlurring) {
          this.ctx.putImageData(this.snapshot, 0, 0); // Restore the snapshot to remove the drawn rectangle
        }

        if (this.isCropping) {
          this.endX = e.offsetX;
          this.endY = e.offsetY;
          const width = this.endX - this.startX;
          const height = this.endY - this.startY;
          const croppedImage = this.ctx.getImageData(this.startX, this.startY, width, height);
          this.$refs.canvas.width = width;
          this.$refs.canvas.height = height;
          this.ctx.putImageData(croppedImage, 0, 0);

          this.saveState();
          this.drawing = false;
        } else if (this.isBlurring) {
          const startX = Math.min(this.startX, e.offsetX);
          const startY = Math.min(this.startY, e.offsetY);
          const width = Math.abs(this.endX - this.startX);
          const height = Math.abs(this.endY - this.startY); this.applyBlur(startX, startY, width, height);
          this.saveState();
          this.drawing = false;
        } else if (this.drawing) {
          this.endX = e.offsetX;
          this.endY = e.offsetY;
          this.ctx.strokeStyle = this.fontColor;
          this.ctx.lineWidth = this.lineWidth;
          if (this.isDrawingRect) {
            this.ctx.strokeRect(this.startX, this.startY, this.endX - this.startX, this.endY - this.startY);

          } else if (this.isDrawingArrow) {
            this.drawArrow(this.ctx, this.startX, this.startY, this.endX, this.endY);
          }
          this.drawing = false;
          this.saveState();
        } else if (this.isAddingText) {
          this.$refs.textInput.style.left = `${this.startX}px`;
          this.$refs.textInput.style.top = `${this.startY}px`;
          this.$refs.textInput.style.display = "block";
          this.$refs.textInput.focus();
        }
      },
      changeToActive(event, active_function) {
        try {
          const element = event.target
          const active_element = document.getElementById('toggled');
          if (element.hasAttribute("id")) {
            this.removeActive();
            return;
          }
          active_element.removeAttribute("id")
          element.setAttribute("id", "toggled");
        }
        catch {
          const element = event.target
          element.setAttribute("id", "toggled");
        }
      },
      removeActive() {
        if (document.getElementById('toggled') != null) {
          document.getElementById('toggled').removeAttribute("id");
          this.invalidateActiveFunction()
        }
      },
      invalidateActiveFunction() {
        this.setActiveFunction()
        this.$refs.canvas.style.cursor = "default";
      },

      commitText() {
        if (this.text) {
          this.ctx.fillStyle = this.fontColor;
          this.ctx.font = `20px ${this.fontFace}`;
          this.ctx.fillText(this.text, this.startX, this.startY);
          this.saveState();
        }
        this.text = "";
        this.$refs.textInput.style.display = "none";

      },
      drawArrow(ctx, fromx, fromy, tox, toy) {
        const lineWidth = ctx.lineWidth;
        const triangleAreaFactor = 5; // Factor for the area of the triangle
        const height = lineWidth * 2; // Height of the triangle (proportional to the line width)
        const base = (triangleAreaFactor * lineWidth); // Calculate the narrow base width

        const sharpnessFactor = 2; // This factor controls the sharpness of the arrowhead

        // Calculate the angle of the line
        const angle = Math.atan2(toy - fromy, tox - fromx);

        // Calculate where the arrow shaft ends (base of the triangle)
        const arrowBaseX = tox - height * sharpnessFactor * Math.cos(angle);
        const arrowBaseY = toy - height * sharpnessFactor * Math.sin(angle);

        // 1. Draw the arrow shaft (from the start to the base of the triangle)
        ctx.beginPath();
        ctx.moveTo(fromx, fromy);
        ctx.lineTo(arrowBaseX, arrowBaseY);
        ctx.stroke();

        // 2. Draw the arrowhead (tip)
        ctx.beginPath();
        ctx.moveTo(tox, toy); // Tip of the arrowhead

        // Left side of the arrowhead (wider side)
        ctx.lineTo(
          tox - height * sharpnessFactor * Math.cos(angle) - (base / 2) * Math.sin(angle),
          toy - height * sharpnessFactor * Math.sin(angle) + (base / 2) * Math.cos(angle)
        );

        // Right side of the arrowhead (wider side)
        ctx.lineTo(
          tox - height * sharpnessFactor * Math.cos(angle) + (base / 2) * Math.sin(angle),
          toy - height * sharpnessFactor * Math.sin(angle) - (base / 2) * Math.cos(angle)
        );

        // Close the triangle (back to the tip of the arrow)
        ctx.closePath();

        // Set the fill color for the arrowhead
        ctx.fillStyle = ctx.strokeStyle; // Ensure arrowhead color matches the shaft
        ctx.fill();

      },
      applyBlur(x, y, width, height) {
        const blurRadius = 10; // Blur radius

        // Get the image data for the selected region with padding around the edges
        const expandedX = x - blurRadius;
        const expandedY = y - blurRadius;
        const expandedWidth = width + 5 * blurRadius;
        const expandedHeight = height + 5 * blurRadius;

        // Create a temporary canvas large enough to handle the expanded region
        const tmpCanvas = document.createElement("canvas");
        tmpCanvas.width = expandedWidth;
        tmpCanvas.height = expandedHeight;
        const tmpCtx = tmpCanvas.getContext("2d");

        // Get the expanded region from the original canvas
        const expandedImageData = this.ctx.getImageData(expandedX, expandedY, expandedWidth, expandedHeight);

        // Put the expanded image data into the temporary canvas
        tmpCtx.putImageData(expandedImageData, 0, 0);

        // Apply the blur filter
        tmpCtx.filter = `blur(${blurRadius}px)`;
        tmpCtx.drawImage(tmpCanvas, 0, 0);  // Apply the blur by redrawing the image onto itself

        // Get the blurred image data, but only the region corresponding to the original selection
        const blurredData = tmpCtx.getImageData(blurRadius, blurRadius, width, height);

        // Put the blurred image data back onto the main canvas in the correct position
        this.ctx.putImageData(blurredData, x, y);

      },
      undo() {
        if (this.historyStep > 0) {
          this.historyStep--;
          this.restoreState(this.historyStep);
          var isChanged = this.lastSavedStep != this.historyStep && (this.historyStep > 0 || this.lastSavedStep > 0)
          this.$emit("StateChanged", isChanged);
        }
      },
      redo() {
        if (this.historyStep < this.history.length - 1) {
          this.historyStep++;
          this.restoreState(this.historyStep);
          var isChanged = this.lastSavedStep != this.historyStep && (this.historyStep > 0 || this.lastSavedStep > 0)
          this.$emit("StateChanged", isChanged);
        }
      },
      onWheel(e) {
        if (e.ctrlKey) {
          e.preventDefault();
          const delta = e.deltaY > 0 ? -0.1 : 0.1;
          const mouseX = e.offsetX;
          const mouseY = e.offsetY;

          this.scale *= 1 + delta;
          this.originX = mouseX - (mouseX - this.originX) * (1 + delta);
          this.originY = mouseY - (mouseY - this.originY) * (1 + delta);

          this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);

          this.ctx.save();
          this.ctx.translate(this.originX, this.originY);
          this.ctx.scale(this.scale, this.scale);
          this.ctx.drawImage(this.image, 0, 0);
          this.ctx.restore();
        }
      },
      EmitSave() {
        this.lastSavedStep = this.historyStep;
        var newImage = this.$refs.canvas.toDataURL();
        this.$emit("ImageSave", newImage);
      },

      setActiveFunction(actionVariableName) {
        if (this.activeFunction != "") this[this.activeFunction] = false;
        this.activeFunction = actionVariableName;
      }

    },
    watch: {
      async base64Image(newValue) {
        if (newValue.startsWith("data:image")) {
          // Source is already base64
          this.loadImage(newValue);
        } else {
          // Assume source is a URL, convert to base64
          const base64 = await this.convertImageUrlToBase64(newValue);
          this.loadImage(base64);
        }
      }
    }
  };
</script>

<style scoped>
  canvas {
    border: 1px solid #000;
  }

  #toolbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 1000; /* Ensure it's above other elements */
    box-shadow: 0px 4px 2px -2px gray;
    padding:5px;
  }

  .no-border {
    display: none;
  }

  .tt-tool {
    width: 32px;
    height: 32px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    /*padding: 3px;*/
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    font-weight: 700;
    cursor: pointer;
    margin-right: 3px;
    min-width: 33px;
    height: 33px !important;
    vertical-align: top;
  }

    .tt-tool.toggled {
      background: #efefef;
      border: 1px solid gray;
      background: #efefef;
      border-radius: 5px;
    }

  #toggled {
    border: 1px solid gray;
    background: #efefef;
    border-radius: 5px;
  }

  .tt-font {
    width: 152px;
    height: 32px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    padding: 3px;
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    font-weight: 700;
    cursor: pointer;
    margin-right: 3px;
    min-width: 33px;
    height: 33px !important;
    vertical-align: top;
  }

  .tt-text {
    width: 96px;
    height: 32px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    padding: 3px;
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    font-weight: 700;
    cursor: pointer;
    margin-right: 3px;
    min-width: 33px;
    height: 33px !important;
    vertical-align: top;
  }
</style>
